<div class="vtz-main-wrapper">
  <div class="vtz-main-container vtz-main-container--home">
    <div class="vtz-title-section vtz-title-section--blue">
      <app-header></app-header>
    </div>    
    @if(electionOpen){
      <main aria-label="form">
        <h1 id="main-title" class="vtz-h1" i18n>Set up 2-Factor Authentication</h1>

        <div class="digits-header">
          <p class="vtz-text vtz-text--wide vtz-text--center" i18n>Set up your 6-digit authentication code using Google Authenticator, Microsoft Authenticator, OneAuth, or other authentication application.</p>
          @if(isNotMobileScreen) {
            <p class="vtz-text vtz-text--wide vtz-text--center" i18n><strong>ON A LAPTOP OR DESKTOP:</strong> Scan the QR code using a mobile device.</p>
            <p class="vtz-text--center"><img src="{{electorDataService.qrCodeURL()}}" alt="QR Code"></p>
          }
          @if(!isIOS() && isNotBigScreen) {
            <p class="vtz-text vtz-text--wide vtz-text--center" i18n><strong>ON A MOBILE DEVICE: </strong> <a href="{{electorDataService.authAppURL()}}">CLICK HERE</a>.</p>
          }
          <p class="vtz-text vtz-text--wide vtz-text--center" i18n><strong>FOR MANUAL SETUP:</strong> Add the following setup key in an authenticator app.</p>
          <div class="vtz-text vtz-text--wide vtz-text--center center-list">
            <ul class="align-ul">
              <li i18n>Press "COPY KEY" to copy the set up key or tap ●●●●●● to reveal the setup key for transcription.</li>
              <li i18n>Open your authenticator app and tap the "+" button, "Add account," or "Set up account" option.</li>
              <li i18n>Select "Enter a setup key" or "Manual entry" (not QR code scanning).</li>
              <li i18n>Fill in the account information and paste the setup key.</li>
              <li i18n>Tap "Add" or "Save" and the app should immediately start generating 6-digit codes that refresh every 30 seconds.</li>
            </ul>
          </div>
          <div class="token-container">
            <button class="code-toggle-btn" (click)="showCode = !showCode">
              {{ showCode ? token : '●●●●●●' }}
            </button>
          </div>
        </div>

        <div class="vtz-actions">
          <div class="dialog-button-container">
            <button (click)="copySecret()" class="button button-secondary-group" i18n>COPY KEY</button>
            <button class="button button-primary" (click)="toCodeEntry()" i18n="Button label">CONTINUE</button>
          </div>
        </div>
      </main>
    }
  </div>
</div>
